<div class="dm-overlay" *ngIf="show">
  <div class="dm-backdrop" (click)="close()"></div>
  <div class="dm-modal" role="dialog" aria-modal="true">
    <button class="dm-close" aria-label="Close" (click)="close()">✕</button>
    <div class="dm-content">
      <img [src]="assets?.bannerPath" alt="Download app" class="dm-banner" />
      <button class="dm-download-btn" (click)="onDownloadClick()">
        <img [src]="assets?.buttonPath" alt="Download button" />
      </button>
    </div>
  </div>
</div>
